
import React, {useState} from 'react';
import VisDiv from '../frontend_components/VisDiv';
import { v4 as uuidv4 } from 'uuid';
import { keyId, shortId, sortByLabel, positionNumber, removeEmptyProperties, deviceAndNonConfId, deviceSubstitutionStatus  } from '../../lib/utils'; 
import {FiSave } from 'react-icons/fi'
import FieldDropdown from '../FieldDropdown';
import TextField from '../TextField';
import TestButton from '../frontend_components/TestButton';
import { deviceNonConformityDoc } from '../gestioneDatabase/Docs';
import { maintenanceDeadlinesTasksList } from '../../lib/tableData';
import deadlines from '../Deadlines';
import { useStateContext } from '../../context/StateContext';


/**
 * InsertProduct component
 * #offers #manualProduct
 * This component is used to manage the customer products associated with a register template.
 * It renders a ManageDocumentReferenceInOtherDocuments component with the customer products and the template registers.
 * 
 * @param {Object} props The props object passed to the component.
 * @param {Object} props.saveFn The function to save the new generated documents
 * @param {Object} props.data The data object passed to the component.
 * @param {Object} props.data.register The register to manage.
 * @param {Object} props.data.registerTemplate The template registers associated with the register template.
 * @param {Object} props.data.existingProducts The customer products associated with the register template.
 * @param {Object} props.data.returnData If returnData is true, it will return the new generated documents.
 * @param {Object} props.data.siteRegisters The site registers associated with the register template.
 * @param {Object} props.data.nonConformities The non conformities associated with the register template.
 * 
 * @returns {React.Component} The InsertProduct component.
 */
export const InsertProduct = ({saveFn, data={}}) => {

    const {register, registerTemplate, existingProducts, returnData, siteRegisters, nonConformities} = data
    const {client} = useStateContext()
    //console.log("empty doc generated data",emptyDocGeneratedData)
    const [selectedRegister, setSelectedRegister] = useState(register)
    const [positions, setPositions] = useState([])  
    const firstProduct = existingProducts?.[0]
    //const [customerProducts, setCustomerProducts] = useState([])  
    //console.log("dlkamskldmaslkdm", firstProduct)
  
    const consoleData = {
      selectedRegister, existingProducts, firstProduct
    }
    const newDocs = positions?.map?.((doc)=>{
      const newDoc = {
        ...firstProduct,
        quantity: doc?.unit ? doc?.unit : "1",
        unit: doc?.unit,
        _id: doc?._id,
        _key: doc?._key,
        hide: false,
        addedLocation: true,
        deviceNonConformityId: doc?.deviceNonConformityId,
        nonConformityId: doc?.nonConformityId,
        nonConformity: doc?.nonConformity,
        location: ` ${doc?.value}`,
        deviceId: doc?.deviceId,
      }
      return newDoc
    })
  
    const addProducts = (e) => {
      e?.stopPropagation();
  
      //console.log("FIRST PRODUCT", firstProduct)
      saveFn(newDocs)
      setPositions([])
    }
  
    const positionsFilter = (device) => {
      const devicesWithOfferProperty = !Array.isArray(selectedRegister?.devices) ? [] : selectedRegister?.devices?.filter?.((dev)=>dev?.fields?.some?.((x)=>x?.values?.some?.((t)=>t?._id == firstProduct?.offerPropertyId)))
      //if(devicesWithOfferProperty?.length > 0) console.log("FOUND nerjfnerjf", devicesWithOfferProperty)
      if(firstProduct?.offerPropertyId) return devicesWithOfferProperty?.some?.((z)=>z?._id == device?._id) && device?.templateDevice?._ref == firstProduct?.deviceFamilyId && device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)   
      if(firstProduct?.deviceFamilyId) return device?.templateDevice?._ref == firstProduct?.deviceFamilyId && device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)
      return device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)
      
    }
  
    const positionsList = !Array.isArray(selectedRegister?.devices) ? [] : selectedRegister?.devices?.filter?.(positionsFilter)?.map?.((device)=>{
      if(device?.status == "ARCHIVIATO") return
      const position = positionNumber(device)
      const doc = {
        _id: uuidv4(),
        _key: keyId(),
        unit: firstProduct?.unit, 
        deviceId: device?._id,
        label: position,
        value: position,
        device
      }
      return doc
    })?.filter?.((x)=>x)
  
    const labelAndName = (label="", name="") => {
        return `${label} ${name}`
    }
  const returnStatement = () => {
    return (
      <>
      <VisDiv rules={[siteRegisters?.length>0]}>
        <FieldDropdown
                isSearchable="isSearchable"
                initialValue={{...selectedRegister, value: labelAndName(selectedRegister?.label,selectedRegister?.name), label: labelAndName(selectedRegister?.label,selectedRegister?.name)}}
                placeHolder={"SELEZIONA REGISTRO"}
                options={siteRegisters?.map?.((register)=>({...register, value: labelAndName(register?.label, register?.name), label: labelAndName(register?.label, register?.name)}))?.sort(sortByLabel)}
                onChange={(value) => {
                  //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                  setSelectedRegister(value)
                }
                }
            />
      </VisDiv>
      <VisDiv rules={[true]}>
          {/* <button onClick={(e)=>{testFunction(e)}}>test add to list</button> */}
          <TestButton buttonId='skòskqwk993bh' consoleData={consoleData} message='Aggiungi prodotti' />
          <VisDiv rules={[true]} style={{display:"flex", alignItems:"center"}}>
              <div style={{minWidth:"30%"}}>
                <FieldDropdown
                  isMulti={true}
                  isSearchable="isSearchable"
                  initialValue={positions}
                  placeHolder={"AGGIUNGI POSIZIONI"}
                  options={positionsList?.sort(sortByLabel)}
                  onChange={(value) => {
                    //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                    setPositions(value)
                  }
                  }
                />
              </div>
    
                <VisDiv rules={[!returnData]} type='button' className='round-back-button' style={{backgroundColor:"green", marginLeft:"10px"}} onClick={addProducts}>
                  <FiSave            
                      size={15}
                      color={"white"}
                    />
                </VisDiv>
          </VisDiv>
              <VisDiv rules={[positions?.length>0]}>
                {positions?.sort(sortByLabel)?.map?.((position)=>{
                    const device = position?.device
                    const deviceDeadlines = deadlines(device, registerTemplate)
                    const findSupplyNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities
                        ?.find?.((x)=>x?.registers?.some((y)=>register?.template?._ref == y?._ref) && x?.supply)
                    const maintenanceNonConformities =  deviceDeadlines?.data
                    const maintenanceDeviceNonConformities = !Array.isArray(maintenanceNonConformities) ? [] : maintenanceNonConformities?.map((item)=>{
                        const doc = {...deviceNonConformityDoc(item?._id), _id: deviceAndNonConfId(device?._id, item?._id)}
                        return doc 
                      })
                    const isThereSubDeadline = !Array.isArray(maintenanceNonConformities) ? false : maintenanceNonConformities?.some((x)=>x?.substitution)
                    const subStatus = deviceSubstitutionStatus({deviceStatus: device?.status, device: device, deadlines: deviceDeadlines, client})
                    
                    const supplyDeviceNonConformity = () => {
                      if(device?.status !== "DA FORNIRE") return
                      if(!findSupplyNonConformity) return
                      const doc = {...deviceNonConformityDoc(findSupplyNonConformity?._id), _id: deviceAndNonConfId(device?._id, findSupplyNonConformity?._id) }
                      //if(!doc?._id) return
                      return doc
                    }
                    const subDeviceNonConformities = () => {
                      // FOUND THE SUB AND MAINTENANACE NON CONFORMITIES, maintenanceNonConformities, now implement subs
                      if(!isThereSubDeadline && subStatus == "DA SOSTITUIRE") {
                        const daSostituireNonConf = nonConformities?.find((x)=> x?._id == "5a6de70d-8353-4209-8eb9-cb62f5554d4a")
                        const doc = {...deviceNonConformityDoc(daSostituireNonConf?._id), _id: deviceAndNonConfId(device?._id, daSostituireNonConf?._id) }
                        return [...maintenanceDeviceNonConformities, doc]
                      }
                      return [...maintenanceDeviceNonConformities]
                    } 
                    const subSupplyDeviceNonConformities = [
                      supplyDeviceNonConformity() ? supplyDeviceNonConformity() : undefined,
                      ...subDeviceNonConformities() 
                    ]?.filter?.((x)=>x)
                    const allDeviceNonConformities = [...!Array.isArray(device?.nonConformities) ? [] : device?.nonConformities, ...subSupplyDeviceNonConformities]
                    const deviceNonConformitiesExpanded = allDeviceNonConformities
                      ?.map((dNc => {
                        const nonConformity = !Array.isArray(nonConformities) ? [] : nonConformities?.find((x)=>x?._id == dNc?.nonConformity?._ref)
                        return ({...dNc, nonConformity, label: nonConformity?.label, value: dNc?._id})
                      }))
                    const consoleData = {
                      supplyDeviceNonConformity:  supplyDeviceNonConformity(), 
                      position, 
                      deviceNonConformitiesExpanded, 
                      findSupplyNonConformity,
                      maintenanceNonConformities,
                      maintenanceDeviceNonConformities,
                      deviceDeadlines,
                      isThereSubDeadline,
                      subStatus
                    }
                    return(
                      <VisDiv rules={[true]} key={position?._id} style={{display:"flex", alignItems:"center"}}>
                        <TestButton buttonId='pokw1p2ojkwopi12jw' consoleData={consoleData} message='Posizione' />
                        <p style={{padding:"2px"}} >{`Posizione: ${position?.label}`}</p>
                        <p style={{padding:"2px"}} >{` | Unità: `}</p>
                        <TextField 
                            //onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
                            value={position?.unit} 
                            onChange={(e) => setPositions([...!Array.isArray(positions) ? [] : positions?.filter?.((x)=>x?._id !== position?._id), {...position, unit: e.target.value}])} 
                            //label={"UNITA'"}
                            type={"text"}
                            //description={"Inserire il numero di unità. Per esempio se deve uscire più di una volta, come nel caso dei cartelli nelle porte/uscite a doppia anta o nel numero dei Kg per lo smaltimento degli estintori"} 
                        />
                        <VisDiv rules={[deviceNonConformitiesExpanded?.length > 0]}>
                            <FieldDropdown
                              isMulti={false}
                              isSearchable="isSearchable"
                              initialValue={deviceNonConformitiesExpanded?.find((x)=>x?.nonConformity?._id == position?.nonConformityId)}
                              placeHolder={"ASSEGNA A NON CONFORMITA'"}
                              options={deviceNonConformitiesExpanded?.filter((x)=>x?.status !== "ARCHIVIATO" && x?.status !== "COMPLETATO")}
                              onChange={(value) => setPositions([...!Array.isArray(positions) ? [] : positions?.filter?.((x)=>x?._id !== position?._id), 
                                {
                                  ...position, 
                                  deviceNonConformityId: value?._id, 
                                  nonConformityId: value?.nonConformity?._id, 
                                  nonConformity: value?.nonConformity?.label
                                }])}
                            />
    {/*                       <FieldDropdown
                            isMulti={false}
                            isSearchable="isSearchable"
                            //initialValue={client}
                            placeHolder={"ASSEGNA A NON CONFORMITA"}
                            options={positionsList?.sort(sortByLabel)}
                            onChange={(value) => {
                              //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                              //setPositions(value)
                            }
                          }  /> */}
                        </VisDiv>
                      </VisDiv>
                    )
                  })
                }
    
              </VisDiv>
    
      </VisDiv>
      </>
    )
  }
  
    if (returnData) return ({returnStatement: returnStatement(), data: newDocs})
    return returnStatement()
  }
  